import type { Map as MapboxMap } from 'mapbox-gl';
import { useEffect } from 'react';
import { hasFeatureEnabled } from '../../services/feature';

const RADIO_RANGE_LAYERS = [
  'radio-range-definitions fill',
  'radio-range-definitions line',
  'radio-range-definitions symbol',
] as const;

/**
 * Custom hook to manage radio range layer visibility in Mapbox
 * @returns cleanup function to hide layers on unmount
 */
export const useRadioRangeLayers = (map?: MapboxMap) => {
  if (!map) {
    return;
  }

  // oxlint-disable-next-line react-hooks/rules-of-hooks -- legacy
  useEffect(() => {
    if (!map || !hasFeatureEnabled('vhf-radio-ranges')) {
      return;
    }

    try {
      // Show layers if they're not already visible
      RADIO_RANGE_LAYERS.forEach((layer) => {
        if (map.getLayoutProperty(layer, 'visibility') !== 'visible') {
          map.setLayoutProperty(layer, 'visibility', 'visible');
        }
      });
    } catch (e) {
      // Do nothing - layers might not exist yet
    }

    // Cleanup function to hide layers on unmount
    return () => {
      RADIO_RANGE_LAYERS.forEach((layer) => {
        try {
          map.setLayoutProperty(layer, 'visibility', 'none');
        } catch (e) {
          // Do nothing - layers might not exist anymore
        }
      });
    };
  }, [map]);
};
